export default {
  plugins: {
    emptyDataPlugin: {
      afterDraw(chart) {
        const datasets = chart.data.datasets.filter(
          ds => ds.data.filter(x => x != null).length > 0,
        );
        if (datasets.length === 0) {
          // No data is present
          const ctx = chart.chart.ctx;
          const width = chart.chart.width;
          const height = chart.chart.height;
          chart.clear();

          ctx.save();
          ctx.textAlign = 'center';
          ctx.fillStyle = '#000000';
          ctx.textBaseline = 'middle';
          ctx.font = "16px normal 'Helvetica Nueue'";
          ctx.fillText('No data to display', width / 2, height / 2);
          ctx.restore();
        }
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/charts.js